import { useEffect, useState } from "react"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import RsvpBox from "../RsvpBox"
import DynamicStepContent from "./DynamicStepContent"
import fallbackStepIcon from "../../icon/result-icon.svg"
import { resolveTranslation } from "../../utils/translations"

interface DynamicStepBoxProps {
  settings: Settings
  stepName: string
  rsvp: RsvpDetails
  setRsvp: React.Dispatch<React.SetStateAction<RsvpDetails | undefined>>
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function DynamicStepBox({
  settings,
  stepName,
  rsvp,
  setRsvp,
  stepPipeline,
  setStep,
}: DynamicStepBoxProps) {
  const [stepStrings, setStepStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  const step = settings.steps.find((x) => x.name === stepName)

  useEffect(() => {
    const newStepStrings = step?.translations ? resolveTranslation(step.translations, language) : undefined

    setStepStrings(newStepStrings)
  }, [language, step])

  const iconSource = step?.icon && step.icon.trim().length > 0 ? step.icon : fallbackStepIcon

  return (
    <div className="box">
      <RsvpBox
        iconAlt={`${stepName}StepIcon`}
        iconSource={iconSource}
        title={stepStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={stepStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <DynamicStepContent
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={stepStrings?.strings ?? []}
          inputType={step?.inputType ?? null}
          stepName={stepName}
          rsvp={rsvp}
          setRsvp={setRsvp}
          stepPipeline={stepPipeline}
          setStep={setStep}
        />
      </RsvpBox>
    </div>
  )
}
